import React, { ComponentType } from 'react';
import classnames from 'classnames';

import { ButtonProps } from '../base-button';

import styles from './text-button.module.scss';

export const TextFlavor = (
	WrappedComponent: ComponentType<ButtonProps>
) => (props: ButtonProps) => {
	return (
		<WrappedComponent
			{...props}
			className={classnames(styles.textButton, props.className)}
		/>
	);
};
